import { createAction, props } from '@ngrx/store';
import { AppEvent, ChannelCreatedEvent, IncomingCallEvent, OutboundEvent, PresenceSnapshot, WebSocketMessage } from './websocket.models';

export const connectSocket = createAction(
  '[Chat Socket] Connect Socket',
  props<{ url: string; token: string; }>()
);

export const connectSocketSuccess = createAction(
  '[Chat Socket] Connect Socket Success'
);

export const connectSocketFailure = createAction(
  '[Chat Socket] Connect Socket Failure',
  props<{ error: string }>()
);

export const disconnectSocket = createAction('[Chat Socket] Disconnect Socket');

export const socketClosed = createAction('[Chat Socket] Socket Closed');

export const subscribeChannel = createAction(
  '[Chat Socket] Subscribe Channel',
  props<{ channelId: string }>()
);

export const subscribeChannelSuccess = createAction(
  '[Chat Socket] Subscribe Channel Success',
  props<{ channelId: string }>()
);

export const unsubscribeChannel = createAction(
  '[Chat Socket] Unsubscribe Channel',
  props<{ channelId: string }>()
);

export const unsubscribeChannelSuccess = createAction(
  '[Chat Socket] Unsubscribe Channel Success',
  props<{ channelId: string }>()
);

export const sendChannelMessage = createAction(
  '[Chat Socket] Send Channel Message',
  props<{
    channelId: string;
    clientMessageId: string;
    message: string;
    messageType: string;
    attributes: Record<string, string>;
  }>()
);

export const sendTypingStatus = createAction(
  '[Chat Socket] Send Typing Status',
  props<{
    channelId: string;
    isTyping: boolean;
  }>()
);

export const receiveSocketEvent = createAction(
  '[Chat Socket] Receive Socket Event',
  props<{ event: OutboundEvent }>()
);

export const receiveChannelMessage = createAction(
  '[Chat Socket] Receive Channel Message',
  props<{ message: WebSocketMessage }>()
);

export const receivePresenceSnapshot = createAction(
  '[Chat Socket] Receive Presence Snapshot',
  props<{ snapshot: PresenceSnapshot }>()
);

export const receiveTypingStatus = createAction(
  '[Chat Socket] Receive Typing Status',
  props<{ message: WebSocketMessage }>()
);

export const receiveAppEvent = createAction(
  '[Chat Socket] Receive App Event',
  props<{ appEvent: AppEvent }>()
);

export const receiveChannelCreated = createAction(
  '[Chat Socket] Receive Channel Created',
  props<{ channelCreated: ChannelCreatedEvent }>()
);

export const receiveIncomingCall = createAction(
  '[Chat Socket] Receive Incoming Call',
  props<{ incomingCall: IncomingCallEvent }>()
);

export const receiveSocketError = createAction(
  '[Chat Socket] Receive Socket Error',
  props<{ error: string }>()
);

export const ignoreSocketEvent = createAction('[Chat Socket] Ignore Socket Event');

export const markPendingMessage = createAction(
  '[Chat Socket] Mark Pending Message',
  props<{
    clientMessageId: string;
    channelId: string;
    message: string;
    messageType: string;
    attributes: Record<string, string>;
    createdAt: string;
  }>()
);

export const resolvePendingMessage = createAction(
  '[Chat Socket] Resolve Pending Message',
  props<{ clientMessageId: string }>()
);

export const clearChannelMessages = createAction(
  '[Chat Socket] Clear Channel Messages',
  props<{ channelId: string }>()
);

export const resetChatSocketState = createAction(
  '[Chat Socket] Reset Chat Socket State'
);